<script setup lang="ts">
import { useSessionTimeoutStore } from "@/stores/sessionTimeout";
import { onBeforeUnmount } from "vue";

const sessionTimeoutStore = useSessionTimeoutStore();

onBeforeUnmount(() => {
    sessionTimeoutStore.touchSession();
});
</script>

<template>
    <div
        id="parameters"
        class="container text-center mb-5"
    >
        <img
            class="mx-auto w-25 my-3"
            src="./../assets/images/stopwatch.svg"
            alt=""
        >
        <h1 class="large blue">
            Session time out
        </h1><p class="error-body py-2">
            Sorry your session has timed out.
        </p><p class="error-body">
            Please
            <router-link to="/login">login</router-link>
            to retrieve your progress or go back to the
            <router-link to="/">
                quote screen
            </router-link>
        </p>
    </div>
</template>
